<button
  (click)="handleLike()"
  [ngClass]="{
    btn: true,
    'btn-sm': true,
    'btn-primary': isFavorite,
    'btn-outline-primary': !isFavorite
  }"
>
  <i class="ion-heart"></i>
  <span>&nbsp; {{ favoritesCount }}</span>
</button>
